module.exports = __webpack_public_path__ + "static/media/circleIconChecked.e97018d9.svg";